import { useCheckLoginSettingStore } from 'src/hooks/stores'
import { AuthTranslator } from 'src/translators'
import { LoginFormSettingEntity } from 'src/types'
import { useCheckLoginSettingMutation } from 'src/types/generated'

export const useLoginFormSetting = () => {
  const [checkLoginSettingMutation] = useCheckLoginSettingMutation()
  const { checkLoginSettingStoreValue, setCheckLoginSettingStoreValue } =
    useCheckLoginSettingStore()

  const loadLoginFormSetting = async (email: string) => {
    const response = await checkLoginSettingMutation({ variables: { email } })
    if (!response.data) {
      throw new Error('No data')
    }

    return AuthTranslator.toLoginFormSettingEntity({
      response: response.data.checkLoginSetting,
      email,
    })
  }

  const updateLoginFormSetting = (entity: LoginFormSettingEntity) => {
    setCheckLoginSettingStoreValue(nowValue => ({ ...nowValue, ...entity }))
  }

  const enableLoginForm = () => {
    setCheckLoginSettingStoreValue(nowValue => ({ ...nowValue, canShowLoginForm: true }))
  }

  return {
    loadLoginFormSetting,
    updateLoginFormSetting,
    enableLoginForm,
    loginFormSetting: checkLoginSettingStoreValue,
  }
}
